var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({style:({
  '--color': _vm.color,
  '--bg--color': _vm.bgColor,
}),on:{"blur":function($event){return _vm.$emit('blur')}},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}},'el-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }